<template>
  <div>
    <div>
      <InternKommentarBubble
        v-on:edit="() => onEditInternKommentar(firstKommentar)"
        :internKommentar="firstKommentar"
        :showVerified="showVerified"
        :canEdit="canEdit"
      />
    </div>
    <div class="mt-xs flex flex-col gap-xs" v-if="expanded">
      <InternKommentarBubble
        v-for="(kommentar, index) in theRest"
        v-on:edit="() => onEditInternKommentar(kommentar)"
        :key="index"
        :internKommentar="kommentar"
        :showVerified="showVerified"
        :canEdit="canEdit"
      />
    </div>
    <div class="flex flex-col items-center">
      <avtalat-button
        class="ml-xs mt-xs"
        id="toggle-interna-kommentarer"
        v-if="!props.disableExpand && hasMoreInternaKommentarer"
        v-on:click.prevent="toggleExpanded"
        style="color: teal; border-color: teal"
        small
        outlined
        color="blue"
        >{{ expanded ? "Dölj alla" : "Visa alla" }}</avtalat-button
      >
    </div>
    <InternKommentarEditModal
      v-if="arendeStore.internKommentar.data"
      v-on:submit="onSubmitInternKommentar"
      v-on:close="onCloseModal"
      :initialValue="arendeStore.internKommentar.data.body"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";

import type { IInternKommentar } from "@/composables/KundserviceAppApiClient";
import { useApi } from "@/composables/useApi";
import { useArbetsgivarearendenStore } from "@/views/arbetsgivare/store";

import InternKommentarEditModal from "../form-components/InternKommentarEditModal.vue";
import InternKommentarBubble from "./InternKommentarBubble.vue";

const arendeStore = useArbetsgivarearendenStore();
const apiClient = useApi();

const props = defineProps<{
  internaKommentarer: IInternKommentar[];
  disableExpand?: boolean;
  showVerified: boolean;
  heading: string;
  canEdit: boolean;
}>();

const expanded = ref(props.disableExpand);
const toggleExpanded = () => (expanded.value = !expanded.value);

const orderedInternaKommentarer = computed(() => {
  return [...props.internaKommentarer].sort((a, b) => {
    return b.createdAt!.getTime() - a.createdAt!.getTime();
  });
});
const firstKommentar = computed(() => orderedInternaKommentarer.value[0]);
const theRest = computed(() => orderedInternaKommentarer.value.slice(1) ?? []);
const hasMoreInternaKommentarer = computed(() => theRest.value.length > 0);

const onEditInternKommentar = async (kommentar: IInternKommentar) => {
  if (arendeStore.internKommentar.isSaving) {
    return;
  }
  arendeStore.internKommentar.data = kommentar;
};

const onCloseModal = () => {
  arendeStore.internKommentar.data = null;
};

const onSubmitInternKommentar = async (text: string) => {
  if (arendeStore.internKommentar.data) {
    await arendeStore.updateInternKommentar(
      arendeStore.internKommentar.data.id,
      text,
      apiClient,
    );
  }
};
</script>
